import { render, staticRenderFns } from "./FireAlertsTable.view.vue?vue&type=template&id=74bf28ff"
import script from "./FireAlertsTable.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireAlertsTable.view.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports